import { lazy } from "react";
import { RouteDefinition } from "../../types";

const CollaborationTypesPage = lazy(() => import("@/pages/CollaborationTypesPage"));
const CollaboratorsPage = lazy(() => import("@/pages/CollaboratorsPage"));
const CollaborationCampaignsPage = lazy(() => import("@/pages/CollaborationCampaignsPage"));
const CampaignEmailsPage = lazy(() => import("@/pages/CampaignEmailsPage"));
const CollabCampaignEmailSettingsPage = lazy(() => import("@/pages/CollabCampaignEmailSettingsPage"));
const CollaborationsSettingsPage = lazy(() => import("@/pages/CollaborationsSettingsPage"));
const CollaborationsEmailSettingsPage = lazy(() => import("@/pages/collaborations/CollaborationsEmailSettingsPage"));

export const collaborationRoutes: RouteDefinition[] = [
  {
    path: "/collaboration-types",
    component: CollaborationTypesPage,
    requiresAuth: true,
    title: "Collaboration Types",
    description: "Manage types of collaborations you offer",
    name: "Collaboration Types",
    category: "Collaborations"
  },
  {
    path: "/collaborators",
    component: CollaboratorsPage,
    requiresAuth: true,
    title: "Collaborators",
    description: "Manage your collaboration partners and leads",
    name: "Collaborators",
    category: "Collaborations"
  },
  {
    path: "/collaboration-campaigns",
    component: CollaborationCampaignsPage,
    requiresAuth: true,
    title: "Collaboration Campaigns",
    description: "Create and manage email campaigns for collaborators",
    name: "Collaboration Campaigns",
    category: "Collaborations"
  },
  {
    path: "/collaboration-campaigns/:campaignId/emails",
    component: CampaignEmailsPage,
    requiresAuth: true,
    title: "Campaign Emails",
    description: "Manage email sequence for campaign",
    name: "Campaign Emails",
    category: "Collaborations"
  },
  {
    path: "/collaboration-campaigns/:campaignId/email-settings",
    component: CollabCampaignEmailSettingsPage,
    requiresAuth: true,
    title: "Campaign Email Settings",
    description: "Configure email sender identity and branding",
    name: "Campaign Email Settings",
    category: "Collaborations"
  },
  {
    path: "/collaborations/email-settings",
    component: CollaborationsEmailSettingsPage,
    requiresAuth: true,
    title: "Collaborations Email Settings",
    description: "Configure email settings for collaboration campaigns",
    name: "Collaborations Email Settings",
    category: "Collaborations"
  },
  {
    path: "/collaborations/settings",
    component: CollaborationsSettingsPage,
    requiresAuth: true,
    title: "Collaborations Settings",
    description: "Configure integration settings for Slack, GHL, and HubSpot",
    name: "Collaborations Settings",
    category: "Collaborations"
  }
];
